<template>
  <section class="SubNav" v-show="store.state.isStarted">
    <div class="LocaleToggle">
      <!-- <select v-model="$i18n.locale">
        <option value="en">en</option>
        <option value="fr">fr</option>
      </select> -->
    </div>
    <nav class="RSLinks">
      <IconButton href="https://www.instagram.com/kenzoparfums/">
        <img src="@/assets/images/instagram.svg" alt="">
      </IconButton>
      <IconButton href="https://www.facebook.com/kenzoparfums">
        <img src="@/assets/images/facebook.svg" alt="">
      </IconButton>
      <IconButton href="https://www.linkedin.com/company/kenzo-parfums/">
        <img src="@/assets/images/linkedin.svg" alt="">
      </IconButton>
    </nav>
  </section>

  <Timeline v-show="store.state.isStarted"/>

  <section class="SoundNav" v-show="store.state.isStarted">
    <div class="SoundNav-switch">
      <Sound />
    </div>
    <IconButton rounded href="https://www.kenzoparfums.com/press/kenzohommeedti.html">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126.87 190.31"><path fill="white" d="M63.44,0a5.77,5.77,0,0,0-5.77,5.77V148.13l-39.28-37a6,6,0,0,0-8.2.18,5.83,5.83,0,0,0,.27,8.2l49,46.13a6.69,6.69,0,0,0,4,1.62,5.15,5.15,0,0,0,4-1.62l49-46.13a5.83,5.83,0,0,0,.27-8.2,6.09,6.09,0,0,0-8.2-.18l-39.28,37V5.77A5.78,5.78,0,0,0,63.44,0ZM5.77,178.77a5.77,5.77,0,0,0,0,11.54H121.1a5.77,5.77,0,1,0,0-11.54Z"/></svg>
    </IconButton>
  </section>

  <Keypoints />
</template>

<script>
import IconButton from '@/components/IconButton'
import Timeline from '@/components/experience/Timeline'
import Keypoints from '@/components/experience/Keypoints'
import Sound from '@/components/experience/Sound'

export default ({
  components: {
    IconButton,
    Timeline,
    Keypoints,
    Sound,
  },
  inject: ['store'],
})
</script>

<style scoped lang="stylus">
.LocaleToggle
  margin-bottom 20px

.SubNav
  display flex
  position absolute
  z-index 9
  right 2%
  bottom 2%
  flex-direction column
  align-items center
  >>> .IconButton
    margin 10px 0
.SoundNav
  display flex
  position absolute
  z-index 9
  left 2%
  bottom 2%
  flex-direction column
  align-items center
  margin 5px 0
  >>> .IconButton
    margin 5px 0

</style>